
const form = document.getElementById('VehicleSearchForm');

let selectors = null;
let observer = null;
let externalScript = null;
let isActive = false;

const carRental = {

    init: function () {

        carRental._initScript();

    },

    _initScript: function () {
        if (isActive) return;
        isActive = true;

        externalScript = document.createElement('script');
        externalScript.setAttribute('src', 'https://rentalcars.queenstownairport.co.nz/widget/searchform.js?element_id=VehicleSearchForm&language=en&pickup_location=zqn&dropoff_location=zqn&age=34&country=NZ');

        externalScript.onload = function () {
            if (isActive) {
                carRental._initForm();
            }
        };

        externalScript.onerror = function () {
            isActive = false;
        };

        document.head.appendChild(externalScript);
    },

    _initForm: function () {

        form.style.display = 'none';

        const config = { attributes: false, childList: true, subtree: false };

        const callback = () => {
            if (!isActive) return;

            selectors = {
                locationSection: form.getElementsByClassName('republic-section-locations')[0],
                dateSection: form.getElementsByClassName('republic-section-dates')[0],
                driverSection: form.getElementsByClassName('republic-section-driver')[0],
                buttonSection: form.getElementsByClassName('republic-section-button')[0]
            };

            if (selectors.locationSection && selectors.dateSection && selectors.driverSection && selectors.buttonSection) {
                carRental._initFormManipulate();
            }
        };

        observer = new MutationObserver(callback);
        observer.observe(form, config);
    },

    _initFormManipulate: function () {

        carRental._reFrameLocations();
        carRental._updateLocationLabels();
        carRental._reFrameTimesAndDates();
        carRental._updateDateLabels();
        carRental._reFrameDriverAndAge();
        carRental._updateButtonText();
        carRental._updateNationalityLabel();
        carRental._showForm();

        if (observer) {
            observer.disconnect();
        }
    },

    //================================= Locations
    _reFrameLocations: function () {

        var locationCheckBox = selectors.locationSection.getElementsByClassName('republic-row')[0];
        locationCheckBox.style.display = 'none';

        let returnLocation = selectors.locationSection.getElementsByClassName('republic-field')[1];
        returnLocation.classList.remove('republic-hide');

        let dropoffLocation = selectors.locationSection.getElementsByClassName('republic-field')[2];
        if (dropoffLocation) {
            dropoffLocation.classList.add('republic-hide');
        }
    },

    _updateLocationLabels: function () {

        let pickupLabel = selectors.locationSection.getElementsByClassName('republic-label')[0];
        let returnLabel = selectors.locationSection.getElementsByClassName('republic-label')[1];

        pickupLabel.innerHTML = "Pick Up Location";
        returnLabel.innerHTML = "Return Location";
    },

    //================================= Dates and Times
    _reFrameTimesAndDates: function () {

        let pickupTime = selectors.dateSection.getElementsByClassName('republic-time')[0];
        let returnTime = selectors.dateSection.getElementsByClassName('republic-time')[1];

        let timeSection = document.createElement('div');

        timeSection.className = 'republic-section republic-section-times';
        timeSection.appendChild(pickupTime);
        timeSection.appendChild(returnTime);

        let pickupTimeLabel = document.createElement('div');
        pickupTimeLabel.className = 'republic-label';
        pickupTimeLabel.innerHTML = 'Pick Up Time';

        let returnTimeLabel = document.createElement('div');
        returnTimeLabel.className = 'republic-label';
        returnTimeLabel.innerHTML = 'Return Time';

        timeSection.getElementsByClassName('republic-field')[0].prepend(pickupTimeLabel);
        timeSection.getElementsByClassName('republic-field')[1].prepend(returnTimeLabel);

        selectors.dateSection.parentNode.insertBefore(timeSection, selectors.driverSection);
    },

    _updateDateLabels: function () {
        let pickupLabel = selectors.dateSection.getElementsByClassName('republic-label')[0];
        let returnLabel = selectors.dateSection.getElementsByClassName('republic-label')[1];

        pickupLabel.innerHTML = "Pick Up Date";
        returnLabel.innerHTML = "Return Date";
    },

    //================================= Driver and Age
    _reFrameDriverAndAge: function () {
        let driverCheckBox = selectors.driverSection.getElementsByClassName('republic-row')[0];
        let driverAndAge = selectors.driverSection.getElementsByClassName('republic-row')[1];

        driverAndAge.classList.remove('republic-hide');
        driverCheckBox.style.display = 'none';
    },

    //================================= Button
    _updateButtonText: function () {
        selectors.buttonSection.getElementsByTagName('span')[0].innerHTML = 'FIND A VEHICLE';
        selectors.buttonSection.getElementsByTagName('span')[0].onclick = carRental._dataTag;
    },

    _updateNationalityLabel: function () {
        let nationalityLabel = selectors.driverSection.getElementsByClassName('republic-country')[0].getElementsByClassName('republic-label')[0];
        nationalityLabel.innerHTML = "I Live In";
    },

    _showForm: function () {
        form.style.display = 'block';
    },

    _dataTag: function () {

        window.dataLayer = window.dataLayer || [];

        let formData = {

            PickUpLocation: document.getElementsByClassName('select2-selection__rendered')[0].innerText,
            ReturnLocation: document.getElementsByClassName('select2-selection__rendered')[1].innerText,
            PickUpTime: document.getElementsByClassName('select2-selection__rendered')[2].innerText,
            ReturnTime: document.getElementsByClassName('select2-selection__rendered')[3].innerText,
            ILiveIn: document.getElementsByClassName('select2-selection__rendered')[4].innerText,

            PickUpDate: document.getElementsByName('start_date')[0].value,
            ReturnDate: document.getElementsByName('end_date')[0].value,
            Age: document.getElementsByName('age')[0].value,

            gtm: {
                uniqueEventId: (new Date().getTime() + new Date().getTimezoneOffset() * -60000).toString().substr(2, 10)
            }
        };

        dataLayer.push({ "event": "RentalCarSubmission", "data": formData });
    }
}

export { carRental };